import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCodeAuditApi, getCodeStandardApi, getUploadStandardApi } from "../../end-points/codeAudit";
import { toast } from "react-toastify";

const initialState = {
  showCodeAudit: false,
  showOverview: false,
  repoPath: "",
  source_language: "",
  target_language: "",
  loading: false,
  codeAudit: "",
  guidelineContent: ""
}

export const getCodeAudit = createAsyncThunk(
  "codeAudit/getCodeAudit",
  async(payload, { rejectWithValue }) => {
    try {
      const response = await getCodeAuditApi(payload);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const getCodeStandard = createAsyncThunk(
  "codeAudit/getCodeStandard", getCodeStandardApi
)

export const getUploadStandard = createAsyncThunk(
  "codeAudit/getUploadStandard", getUploadStandardApi
)

export const codeAuditSlice = createSlice({
  name: "CodeAudit",
  initialState,
  reducers: {
    setShowCodeAudit: (state, action) => {
      state.showCodeAudit = action.payload;
      if (action.payload === true) {
        state.showOverview = false;
      }
    },
    setShowOverview: (state, action) => {
      state.showOverview = action.payload;
      if (action.payload === true) {
        state.showCodeAudit = false;
      }
    },
    resetAudit: (state) => {
      state.codeAudit = ""
      state.guidelineContent = ""
      state.showCodeAudit = false;
      state.showOverview = false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getCodeAudit.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
    })
    builder.addCase(getCodeAudit.fulfilled, (state, action) => {
      console.log("Success...", state, action);
      state.codeAudit = action.payload.codeAudit;
      state.showCodeAudit = true;
      state.showOverview = false;
      state.loading = false;
      const sessionValue = JSON.parse(sessionStorage.getItem("code-conversion-response"))
      sessionStorage.setItem(
        "code-conversion-response",
        JSON.stringify({
          ...sessionValue,
          audit: action.payload.codeAudit
        })
      );
      console.log("CodeAudit", state.codeAudit);
    })
    builder.addCase(getCodeAudit.rejected, (state, action) => {
      console.log("Error", state, action);
      toast.error(action.error.message)
      state.loading = false;
    })

    builder.addCase(getCodeStandard.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
    })
    builder.addCase(getCodeStandard.fulfilled, (state, action) => {
      console.log("Success...", state, action);
      state.guidelineContent = action.payload.details;
      state.loading = false;
    })
    builder.addCase(getCodeStandard.rejected, (state, action) => {
      console.log("Error", state, action);
      toast.error(action.error.message)
      state.loading = false;
    })

    builder.addCase(getUploadStandard.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
    })
    builder.addCase(getUploadStandard.fulfilled, (state, action) => {
      console.log("Success...", state, action);
      state.loading = false;
    })
    builder.addCase(getUploadStandard.rejected, (state, action) => {
      console.log("Error", state, action);
      toast.error(action.error.message)
      state.loading = false;
    })
  }
})

// Action creators are generated for each case reducer function
export const { setShowCodeAudit, setShowOverview, resetAudit } = codeAuditSlice.actions;

export default codeAuditSlice.reducer